import { Component, OnInit, ChangeDetectorRef, ViewChild, TemplateRef } from '@angular/core';
import { ValidationService } from '../validation.service';
import { SnackbarService } from '../snackbar.service';
import { HttpService } from '../http.service';
import { Router } from '@angular/router';
// import { _ } from 'underscore';
import * as _ from 'underscore';
import { Messages } from '../constants/messages'
import { TranslateService } from '@ngx-translate/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MatDialog } from '@angular/material';
import { environment } from 'src/environments/environment';
declare var google: any;

@Component({
  selector: 'app-sign-up',
  templateUrl: './sign-up.component.html',
  styleUrls: ['./sign-up.component.scss']
})
export class SignUpComponent implements OnInit {

  documents = [];
  selectedVehicle: any = {
    _id: '',
    name: ''
  };
  showLoader = false;
  vehicles = [];
  sameLocFlag = false;
  showTaxInput = false;
  signUpData: any = {
    name: '',
    unit_name: '',
    is_tax_exempted: false,
    inviteCode: '',
    location: {
      area: '',
      pincode: '',
      mobile: '',
      city: '',
      locality: '',
      latitude: 0,
      longitude: 0,
      country_code: ''
    },
    unitLocation: {
      area: '',
      pincode: '',
      mobile: '',
      locality: '',
      city: '',
      latitude: 0,
      longitude: 0,
      country_code: ''
    },
    user: {
      name: '',
      email_id: '',
      mobile: '',
      password: '',
      confirmPassword: ''
    },
    vehicle_types: [],
  };
  passwordStrengthPassedCheck = {
    minimumChars: false,
    oneSpecial: false,
    oneCapital: false,
    oneSmall: false,
    oneNumeric: false,
    overall: false
  };
  selectedCountry;
  selectedUnitCountry;
  countries;
  disableCheckbox = true;
  messages = new Messages();
  VideoLinkRef: any;
  video_URL = this.sanitizer.bypassSecurityTrustResourceUrl(environment.SIGN_UP);
  @ViewChild("openVideos", { static: true }) openVideos: TemplateRef<any>;
  constructor(private dialog: MatDialog, private http: HttpService, private valid: ValidationService, private snackbar: SnackbarService,
    private route: Router, private translate: TranslateService, private changeDetectorRef: ChangeDetectorRef, private sanitizer: DomSanitizer) { }
  file: string;
  myFiles: string[] = [];


  ngOnInit() {
    // this.initAutoSuggestions();
    this.initvehicles();
    this.getCountryCodes();
    const token = this.route.url.substr(1).split('=');
    this.signUpData.inviteCode = token[1];
  }

  passwordStrengthChecker() {
    this.passwordStrengthPassedCheck.oneSpecial = new RegExp('(?=.*?[#?!@$%^&*-])').test(this.signUpData.user.password);
    this.passwordStrengthPassedCheck.oneCapital = new RegExp('(?=.*?[A-Z])').test(this.signUpData.user.password);
    this.passwordStrengthPassedCheck.oneSmall = new RegExp('(?=.*?[a-z])').test(this.signUpData.user.password);
    this.passwordStrengthPassedCheck.oneNumeric = new RegExp('(?=.*?[0-9])').test(this.signUpData.user.password);
    this.passwordStrengthPassedCheck.minimumChars = this.signUpData.user.password.length >= 8;
    this.passwordStrengthPassedCheck.overall = new RegExp('^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$').test(this.signUpData.user.password);

  }
  initvehicles() {
    this.http.get('vehicle_type/all').subscribe(
      (data: any) => {
        if (data.statusCode == 200) {
          const result = data.data;
          if (result && result.length) {
            result.forEach(element => {
              const temp: any = {
                _id: '',
                name: ''
              };
              temp._id = element._id;
              temp.name = element.name;
              this.vehicles.push(temp);
            });
          }
        }
      }
    );
  }
  onFileSelect(event) {
    for (let i = 0; i < (event.target.files.length); i++) {
      this.file = event.target.files[i];
      this.myFiles.push(event.target.files[i]);
    }
  }

  initAutoSuggestions() {

    const input = document.getElementById('addressSearch');
    const unitLoc = document.getElementById('addressSearchUnit');
    const options = {

    };

    const autoComplete = new google.maps.places.Autocomplete(input, options);
    const autoCompleteUnit = new google.maps.places.Autocomplete(unitLoc, options);

    const context = this.signUpData;
    autoComplete.addListener('place_changed', () => {

      const place = autoComplete.getPlace();
      context.location.latitude = place.geometry.location.lat();
      context.location.longitude = place.geometry.location.lng();
      context.location.area = place.formatted_address;
      context.location.country_code = (place.address_components[place.address_components.length - 2].types.includes("country")) ? place.address_components[place.address_components.length - 2].short_name : ''; //"country_code"
      context.location.pincode = (place.address_components[place.address_components.length - 1].types.includes("postal_code")) ? place.address_components[place.address_components.length - 1].long_name : ''; //"postal_code"


      if (!context.location.country_code) {
        context.location.country_code = (place.address_components[place.address_components.length - 1].types.includes("country")) ? place.address_components[place.address_components.length - 1].short_name : ''; //"country_code"
      }


      const city = _.filter(place.address_components, (city) => {
        if (_.contains(city.types, 'locality')) {
          return city.long_name;
        } else if (_.contains(city.types, 'administrative_area_level_1')) {
          return city.long_name;
        }
      });
      context.location.city = city[0].long_name;

      if (this.sameLocFlag) {

        context.unitLocation.latitude = context.location.latitude;
        context.unitLocation.longitude = context.location.longitude;
        context.unitLocation.area = context.location.area;
        context.unitLocation.country_code = context.location.country_code;
        context.unitLocation.pincode = context.location.pincode;
        context.unitLocation.city = context.location.city;
        this.signUpData.unitAddress = this.signUpData.address;
      }
      if (!place.geometry) {
        return;
      }
      // if (context.location.country_code == '') {
      //   this.snackbar.openSnackBar(this.translate.instant('MESSAGE.SIGN_UP.VALIDATION.differentAddress'), '', 'err');
      // }
    });

    autoCompleteUnit.addListener('place_changed', () => {

      const place = autoCompleteUnit.getPlace();
      context.unitLocation.latitude = place.geometry.location.lat();
      context.unitLocation.longitude = place.geometry.location.lng();
      context.unitLocation.area = place.formatted_address;
      context.unitLocation.country_code = (place.address_components[place.address_components.length - 2].types.includes("country")) ? place.address_components[place.address_components.length - 2].short_name : ''; //"country_code"
      context.unitLocation.pincode = (place.address_components[place.address_components.length - 1].types.includes("postal_code")) ? place.address_components[place.address_components.length - 1].long_name : ''; //"postal_code"




      const city = _.filter(place.address_components, (city) => {
        if (_.contains(city.types, 'locality')) {
          return city.long_name;
        } else if (_.contains(city.types, 'administrative_area_level_1')) {
          return city.long_name;
        }
      });
      context.unitLocation.city = city[0].long_name;

      if (!place.geometry) {
        return;
      }
    });
  }
  sameLoc(flag) {
    let unitMobile: any = '';

    if (flag) {
      this.signUpData.unitLocation.latitude = this.signUpData.location.latitude;
      this.signUpData.unitLocation.longitude = this.signUpData.location.longitude;
      this.signUpData.unitLocation.area = this.signUpData.location.area;
      this.signUpData.unitLocation.locality = this.signUpData.location.locality;
      this.signUpData.unitLocation.pincode = this.signUpData.location.pincode;
      this.signUpData.unitLocation.city = this.signUpData.location.city;
      this.signUpData.unitAddress = this.signUpData.address;
      let selectedCountry = this.countries.filter((country) => {
        return country.iso_alpha_code == this.signUpData.location.country_code;
      })[0];
      this.selectUnitCountry(selectedCountry);
    } else {
      unitMobile = this.signUpData.unitLocation.mobile;
      this.signUpData.unitLocation = {};
      this.signUpData.unitAddress = '';
      this.signUpData.unitLocation.mobile = unitMobile;
      this.selectedCountry = {}
    }
  }
  checkAddress() {
    if (this.signUpData.location.area && this.signUpData.location.pincode && this.signUpData.location.city && this.signUpData.location.country_code) {
      this.disableCheckbox = false;
    } else {
      this.disableCheckbox = true;
    }
  }

  getCountryCodes() {
    this.http.get('country/all').subscribe((response: any) => {
      if (response.statusCode == 200) {
        this.countries = response.data;
      }
    },
      (err) => {
        this.snackbar.openSnackBar(err.error.message, '', 'err');
      })
  }

  selectCountry(country) {
    this.selectedCountry = country;
    this.signUpData.location.country_code = country.iso_alpha_code;
  }

  selectUnitCountry(country) {
    this.selectedUnitCountry = country;
    this.signUpData.unitLocation.country_code = country.iso_alpha_code;
  }
  selectvehicle(vehicle, event) {
    if (event.source._selected && this.signUpData.vehicle_types.indexOf(vehicle._id) == -1) {
      this.signUpData.vehicle_types.push(vehicle._id);
    } else if (this.signUpData.vehicle_types.indexOf(vehicle._id) != -1) {
      this.signUpData.vehicle_types.splice(this.signUpData.vehicle_types.indexOf(vehicle._id), 1);
    }
  }
  // validate all input values
  validate(data): Boolean {
    let validFlag: Boolean = true;
    console.log(data)
    if (data.location.country_code === '' || data.unitLocation.country_code === '') {
      this.snackbar.openSnackBar(this.translate.instant('MESSAGE.SIGN_UP.VALIDATION.differentAddress'), '', 'err');
      validFlag = false;
      return;
    }
    // check for enterprise details
    if (!this.valid.isEmpty(data.name) && !this.valid.isEmpty(data.location.area) && !this.valid.isEmpty(data.location.city) && !this.valid.isEmpty(data.location.mobile) && !this.valid.isEmpty(data.location.pincode) && !this.valid.isEmpty(data.vehicle_types)) {
      //check for Unit details
      if (this.valid.isEmpty(data.unit_name) || this.valid.isEmpty(data.unitLocation.area) || this.valid.isEmpty(data.unitLocation.city) || this.valid.isEmpty(data.unitLocation.pincode) || this.valid.isEmpty(data.unitLocation.mobile)) {

        this.snackbar.openSnackBar(this.messages.SIGN_UP.VALIDATION.UNIT_DETIALS, '', 'err');
        validFlag = false;
      } else if (!data.is_tax_exempted) {
        if (!data.tax_number) {
          this.snackbar.openSnackBar(this.messages.SIGN_UP.VALIDATION.TAX_NUMBER, '', 'err');
          validFlag = false;
        } else if (!this.valid.isGst(data.tax_number)) {
          this.snackbar.openSnackBar(this.translate.instant('MESSAGE.ACCOUNTSETTINGS.validGst'), '', 'err');
          validFlag = false;
        }
      } else if (this.valid.isEmpty(data.location.mobile) || this.valid.isEmpty(data.unitLocation.mobile)) {
        this.snackbar.openSnackBar(this.messages.SIGN_UP.VALIDATION.MOBILE_NUMBER, '', 'err');
        validFlag = false;
      } else if (!this.valid.isEmpty(data.user.name) && !this.valid.isEmpty(data.inviteCode) && !this.valid.isEmpty(data.user.email_id) && !this.valid.isEmpty(data.user.mobile) && !this.valid.isEmpty(data.user.password) && !this.valid.isEmpty(data.user.confirmPassword)) {
        // check for user account inputs
        if (!this.valid.isEmail(data.user.email_id)) {
          this.snackbar.openSnackBar(this.messages.SIGN_UP.ERROR.INVALID_EMAIL, '', 'err');
          validFlag = false;
        }
        if (!this.valid.isMobile(data.user.mobile)) {
          this.snackbar.openSnackBar(this.messages.SIGN_UP.ERROR.INVALID_MOBILE_NO, '', 'err');
          validFlag = false;
        }
        if (!this.valid.isPassword(data.user.password) || !this.valid.isPassword(data.user.confirmPassword)) {
          this.snackbar.openSnackBar(this.messages.SIGN_UP.ERROR.PASSWORD_LENGTH, '', 'err');
          validFlag = false;
        } else {
          if (data.user.password !== data.user.confirmPassword) {
            this.snackbar.openSnackBar(this.messages.SIGN_UP.ERROR.PASSWORD_MATCH, '', 'err');
            validFlag = false;
          }
        }
      } else {
        this.snackbar.openSnackBar(this.messages.SIGN_UP.VALIDATION.ACCOUNT_DETAILS, '', 'err');
        validFlag = false;
      }
    } else {
      this.snackbar.openSnackBar(this.messages.SIGN_UP.VALIDATION.FILL_DETAILS, '', 'err');
      validFlag = false;
    }
    return validFlag;
  }
  submit() {
    const valid = this.validate(this.signUpData);
    if (valid) {
      const confirmPwd: any = this.signUpData.user.confirmPassword;
      delete this.signUpData.address;
      delete this.signUpData.user.confirmPassword;
      delete this.signUpData.location.cityName;
      if (!this.signUpData.location.locality) {
        delete this.signUpData.location.locality
      }
      if (!this.signUpData.unitLocation.locality) {
        delete this.signUpData.unitLocation.locality;
      }
      if (!this.sameLocFlag) {
        delete this.signUpData.unitAddress;
      }
      if (this.signUpData.is_tax_exempted) {
        delete this.signUpData.tax_number;
      }
      this.showLoader = true;
      this.http.post('carrier/signup', this.signUpData).subscribe(
        (data) => {
          this.snackbar.openSnackBar('Carrier Signup Successful');
          this.showLoader = false;

          this.route.navigateByUrl('login');
        },
        (err: any) => {
          this.showLoader = false;
          this.signUpData.user.confirmPassword = confirmPwd;
          this.snackbar.openSnackBar(err.error.message, '', 'err');
        }
      );
    }
  }

  openAddVehicleVideoLink() {

    this.VideoLinkRef = this.dialog.open(this.openVideos, {

    });
  }
}
